export class UploadDocumentTracking {
    public RentalApplicationKey: number;
    public RentalApplicantKey: number;
    public OptionClicked: string;

    constructor(
        rentalApplicationKey: number,
        optionClicked: string,
    ) {
        this.RentalApplicationKey = rentalApplicationKey;
        this.OptionClicked = optionClicked;
    }
}
